import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ReplaceVideoPointsService from '../../Services/Mutations/ReplaceContentPoints'
import ModifyContentPoints from '../../Services/Mutations/ModifyContentPoints'
class AddPointsToContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			pointsModalVisible: false,
			modifyType: 'add',
			modifyPoints: '1000',
			otherPoints: false,
			mask: '[0000000000]',
			currentUserDetails: {},
			replacePoints: '',
		}
	}
	handleModal = (visible) => {
		this.setState({ pointsModalVisible: visible })
	}

	closePointsModal = () => {
		this.setState({
			modifyType: 'add',
			modifyPoints: '1000',
			otherPoints: false,
			pointsModalVisible: false,
		})
	}
	//handle add or remove radio buttons
	handleModifyOption = (value) => {
		this.setState({ modifyType: value })
	}
	handleModifyPoints = (points) => {
		points
			? this.setState({ otherPoints: false, modifyPoints: points })
			: this.setState({ otherPoints: true, modifyPoints: points })
	}
	handleOtherPoints = (e) => {
		const points = e.target.value
		this.setState({ modifyPoints: points.replace(/[^0-9]/gi, ''), otherPoints: true })
	}

	handleReplacePoints = (e) => {
		const points = e.target.value
		this.setState({ replacePoints: points.replace(/[^0-9]/gi, '') })
	}
	buttonVisibilityFunc = () => {
		const { otherPoints, modifyPoints, modifyType, replacePoints } = this.state
		const otherSelectedCondition = otherPoints && !modifyPoints
		const replaceSelectedCondition = modifyType == 'replace' && replacePoints == ''
		return otherSelectedCondition || replaceSelectedCondition
	}
	handleModifyPointsToVideo = async (videoInfo) => {
		const { modifyType, modifyPoints, currentUserDetails, replacePoints } = this.state
		const Points = modifyType == 'add' ? modifyPoints : -modifyPoints
		let loggedInUserHandle = ''
		const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split('@')
			loggedInUserHandle = '@' + emailParams[0]
		}
		const parameters = {
			contentID: this.props.item.PK,
			points: parseInt(Points),
			ModeratorID: Auth.user.username,
		}
		const replaceInput = {
			contentID: this.props.item.PK,
			points: parseInt(replacePoints),
			ModeratorID: Auth.user.username,
		}
		this.setState({ pointsModalVisible: false })
		if (modifyType == 'replace') {
			try {
				console.log(replaceInput, 'replaceInput')
				const response = await ReplaceVideoPointsService(replaceInput)
				console.log(response, 'responseeeeeeeeeeee')
				if (response.statusCode == 'A262') {
					this.props.displayToast('success', 'Content Points Replaced Successfully')
					this.props.replaceContentPoints(this.props.item.PK, parseInt(replacePoints))
				} else {
					this.props.displayToast('error', 'Failed To Replace Content Points')
				}
			} catch (error) {
				return error
			}
		} else {
			try {
				console.log(parameters, 'parameters')
				const response = await ModifyContentPoints(parameters)
				console.log(response, 'responseeeeeeeeeeee=============')

				if (response.statusCode == 'A261') {
					this.props.updateContentPoints(this.props.item.PK, parseInt(Points))
					modifyType == 'add'
						? this.props.displayToast('success', 'Points Added To Content Successfully')
						: this.props.displayToast('success', 'Content Points Removed Successfully')
				} else {
					modifyType == 'add'
						? this.props.displayToast('error', 'Failed To Add Points To Content')
						: this.props.displayToast('error', 'Failed To Remove Points From Content')
				}
			} catch (error) {
				return error
			}
		}

		this.setState({ modifyPoints: 1000, modifyType: 'add', otherPoints: false })
	}

	render() {
		const {
			pointsModalVisible,
			modifyType,
			otherPoints,
			modifyPoints,
			mask,
			replacePoints,
		} = this.state
		return (
			<>
				{this.props.rank ? (
					<div
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<label>Modify Points</label>
					</div>
				) : (
					<div

						data-toggle='tooltip'
						title={`Modify Points`}
						style={{ fontSize: '12px' }}
						class='col-md-3 faIconClass'
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<i class='fas fa-star fa-lg' />
					</div>
				)}

				<Modal show={pointsModalVisible} onHide={() => this.closePointsModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Modify Points</text>
							<div class='col-md-3'>
								<input
									value={modifyType}
									type='radio'
									checked={modifyType == 'add'}
									onClick={() => {
										this.handleModifyOption('add')
									}}
								></input>
								<text for={'add'}>{'add'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={modifyType}
									type='radio'
									checked={modifyType == 'remove'}
									onClick={() => {
										this.handleModifyOption('remove')
									}}
								></input>
								<text for={'remove'}>{'remove'}</text>
							</div>
							<div class='col-md-3'>
								<input
									value={modifyType}
									type='radio'
									checked={modifyType == 'replace'}
									onClick={() => {
										this.handleModifyOption('replace')
									}}
								></input>
								<text for={'replace'}>{'replace'}</text>
							</div>
						</div>
						{modifyType != 'replace' ? (
							<div class='row'>
								<div>
									<input
										value={modifyPoints}
										type='radio'
										checked={modifyPoints == '1000'}
										onClick={() => {
											this.handleModifyPoints('1000')
										}}
									></input>
									<text for={'1000'}>{'1000'}</text>
								</div>
								<div>
									<input
										value={modifyPoints}
										type='radio'
										checked={modifyPoints == '500'}
										onClick={() => {
											this.handleModifyPoints('500')
										}}
									></input>
									<text for={'500'}>{'500'}</text>
								</div>
								<div>
									<input
										value={modifyPoints}
										type='radio'
										checked={otherPoints}
										onClick={() => {
											this.handleModifyPoints(0)
										}}
									></input>
									<text for={'others'}>{'others'}</text>
								</div>

								{otherPoints ? (
									<div>
										<input
											type='text'
											onChange={(value) => {
												this.handleOtherPoints(value)
											}}
											value={modifyPoints ? modifyPoints : ''}
											placeholder='Please Enter Points'
										></input>
									</div>
								) : null}
							</div>
						) : (
							<div>
								<input
									type='text'
									onChange={(value) => {
										this.handleReplacePoints(value)
									}}
									value={replacePoints}
									placeholder='Please Enter Replace Points'
								></input>
							</div>
						)}
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closePointsModal()}>Cancel</Button>
						{this.buttonVisibilityFunc() ? (
							<Button disabled>Ok</Button>
						) : (
							<Button onClick={() => this.handleModifyPointsToVideo()}>Ok</Button>
						)}
					</Modal.Footer>
				</Modal>
			</>
		)
	}
}

export default AddPointsToContent
